// extracted by mini-css-extract-plugin
export default {"description":"description_XT_vE","button":"button_VFEqT"};